var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 71,
    viewBox: "0 0 115 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4692 2.40467C56.0679 0.562049 58.6747 0.56205 59.2734 2.40467L66.4064 24.3577C66.6741 25.1817 67.442 25.7397 68.3085 25.7397H91.3912C93.3287 25.7397 94.1342 28.2189 92.5668 29.3577L73.8925 42.9254C73.1915 43.4347 72.8982 44.3374 73.1659 45.1615L80.2989 67.1145C80.8976 68.9571 78.7886 70.4894 77.2212 69.3506L58.5468 55.7828C57.8459 55.2736 56.8967 55.2736 56.1957 55.7828L37.5213 69.3506C35.9539 70.4894 33.845 68.9571 34.4437 67.1145L41.5766 45.1615C41.8444 44.3374 41.5511 43.4347 40.8501 42.9254L22.1757 29.3577C20.6083 28.2189 21.4139 25.7397 23.3513 25.7397H46.4341C47.3005 25.7397 48.0684 25.1817 48.3362 24.3577L55.4692 2.40467Z",
    fill: "url(#paint0_linear_3398_57458)",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0746 24.1605L3.57184 16.942",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1524 28.0145H1.71545",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0009 22.1624L11.7824 9.65967",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3563 24.1605L111.859 16.942",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2785 28.0145H113.715",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.43 22.1624L103.648 9.65967",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3398_57458",
    x1: 57.3713,
    y1: 1.02271,
    x2: 57.3713,
    y2: 69.7416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6b7bac569c8effda7e9fa7541f50116f.svg";
export { ForwardRef as ReactComponent };